angular.module('impactx.panel').component('ixCompanyPreviewPanel', {
        bindings: {
            mode: "=",
            name: "=",
            image: "=",
            trns: "="
        },
        controller: 'CompanyPreviewPanelCtrl',
        controllerAs: 'companyPreviewPanelCtrl',
        templateUrl: 'shared/panel/templates/company.preview.panel.tmpl.html'
    }
);